import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import axiosInstance from '../axiosConfig';  // Import the Axios instance

import '../css/Chat.css';  // Custom styles for the chat component

const CookieConsentModal = ({showChat}) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Automatically show the modal when the site is opened
    const consentGiven = localStorage.getItem('cookieConsent');
    if (!consentGiven) {
      setShow(true);
    }
  }, []);

  const handleLogin = async (recaptchaToken) => {
    try {
      // Send an empty POST request to the login endpoint
      //const response = await axios.post('http://localhost:8000/login',{recaptchaToken});
      //const response = await axios.post('http://localhost:8000/login',{captchaToken: recaptchaToken, token : localStorage.getItem('access_token')});
      //const response = await axios.post(`${baseURL}/login`,{captchaToken: recaptchaToken, token : localStorage.getItem('access_token')});

      const response = await axiosInstance.post('/login', {
        captchaToken: recaptchaToken,
        token: localStorage.getItem('access_token'),
      });
  
      
      // Assuming you get a token or session data in the response

      // Store the token or session data in localStorage
      localStorage.setItem('access_token', response.data.access_token);
      localStorage.setItem('session_id', response.data.session_id);

      showChat(true);

    } catch (error) {
      console.error('Error logging in:', error);

    }};

  const handleCaptcha = () => {
    if (window.grecaptcha) {
        window.grecaptcha.ready(() => {
          window.grecaptcha
            .execute("6Lcy0FUqAAAAAAsQUd3aJX0k_tAu4EhFE2Ey4L16", { action: "submit" })
            .then((token) => {
              handleLogin(token);  // Use token for verification
            });
        });
      } else {
        console.error('reCAPTCHA has not been loaded');
      }
  };

    
  const handleAccept = () => {
    // Store consent in localStorage to prevent modal from showing again
    localStorage.setItem('cookieConsent', 'true');
    handleCaptcha();
    setShow(false);

  };

  return (
    <Modal show={show} onHide={handleAccept} backdrop="static" keyboard={false} centered>
      <Modal.Header>
        <Modal.Title>Wir schätzen deine Privatsphäre​</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
        Wir verwenden nur notwendige Cookies, um dein Erlebnis auf unserer Website zu verbessern.
        Dazu gehören Google Analytics, reCAPTCHA und Chat-Handling-Cookies. Es werden keine zusätzlichen Cookies gespeichert.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleAccept}>
          Akzeptieren
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CookieConsentModal;